// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23818cf8%27 d=%27M6 9L1 4h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Form Dense - Compact form layout with 4-column grid
 * Professional, efficient form design
 */

.form-wrapper {
  max-width: 1200px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-lg);
  border-bottom: 1px solid var(--border);
  background-color: var(--bg-toolbar);
}

.form-header-breadcrumb {
  font-size: var(--text-sm);
  color: var(--text-muted);
}

.form-header-breadcrumb a {
  color: var(--accent-l);
  text-decoration: none;
  cursor: pointer;
  transition: color var(--transition-fast);
}

.form-header-breadcrumb a:hover {
  color: #a5b4fc;
}

.form-header-title {
  font-size: var(--text-xl);
  font-weight: var(--fw-semibold);
  color: var(--text-primary);
  margin: 0;
}

.form-header-description {
  font-size: var(--text-sm);
  color: var(--text-muted);
  margin: 0;
}

.form-header-actions {
  display: flex;
  gap: var(--spacing-sm);
}

.form-content {
  padding: var(--spacing-xl);
}

.form-section {
  margin-bottom: var(--spacing-xl);
}

.form-section:last-child {
  margin-bottom: 0;
}

.form-section-title {
  font-size: var(--text-xs);
  font-weight: var(--fw-bold);
  text-transform: uppercase;
  color: var(--text-muted);
  letter-spacing: 0.5px;
  margin: 0 0 var(--spacing-md) 0;
  padding-bottom: var(--spacing-sm);
  border-bottom: 1px solid var(--border);
}

.form-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-lg);
  margin-bottom: var(--spacing-md);
}

.form-row:last-of-type {
  margin-bottom: 0;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full {
  grid-column: 1 / -1;
}

.form-group.col-2 {
  grid-column: span 2;
}

.form-group.col-3 {
  grid-column: span 3;
}

label {
  font-size: var(--text-sm);
  font-weight: var(--fw-medium);
  color: var(--slate-600);
  margin-bottom: var(--spacing-xs);
  display: flex;
  align-items: center;
  gap: 2px;
}

.required {
  color: var(--red-600);
  font-weight: var(--fw-bold);
}

.help-text {
  font-size: var(--text-xs);
  color: var(--slate-400);
  margin-top: 2px;
}

/* Form Controls */
input[type="text"],
input[type="email"],
input[type="password"],
input[type="number"],
input[type="date"],
input[type="time"],
input[type="datetime-local"],
input[type="search"],
select,
textarea {
  font-family: var(--font-primary);
  font-size: var(--text-sm);
  padding: var(--spacing-sm) var(--spacing-md);
  border: 1px solid var(--slate-300);
  border-radius: var(--radius-sm);
  background-color: var(--bg-input);
  color: var(--text-primary);
  transition: all var(--transition-fast);
  appearance: none;
}

input[type="text"]::placeholder,
input[type="email"]::placeholder,
input[type="password"]::placeholder,
input[type="number"]::placeholder,
input[type="search"]::placeholder,
textarea::placeholder {
  color: var(--text-muted);
}

input:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb),.2);
  background-color: rgba(var(--accent-rgb),.07);
}

input:disabled,
select:disabled,
textarea:disabled {
  background-color: var(--bg-toolbar);
  color: var(--text-muted);
  cursor: not-allowed;
}

select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right var(--spacing-md) center;
  padding-right: 28px;
}

textarea {
  resize: vertical;
  min-height: 80px;
}

/* Checkbox & Radio */
input[type="checkbox"],
input[type="radio"] {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
  accent-color: var(--blue-600);
}

.checkbox-group,
.radio-group {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.checkbox-item,
.radio-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  cursor: pointer;
}

.checkbox-item label,
.radio-item label {
  margin-bottom: 0;
  cursor: pointer;
  font-weight: var(--fw-regular);
}

/* Error state */
.form-group.error label {
  color: var(--red-600);
}

.form-group.error input,
.form-group.error select,
.form-group.error textarea {
  border-color: var(--red-600);
}

.form-group.error input:focus,
.form-group.error select:focus,
.form-group.error textarea:focus {
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
  background-color: var(--red-50);
}

.error-message {
  font-size: var(--text-xs);
  color: var(--red-600);
  margin-top: 2px;
}

/* Success state */
.form-group.success input,
.form-group.success select,
.form-group.success textarea {
  border-color: var(--green-600);
}

/* Responsive */
@media (max-width: 992px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }

  .form-group.col-3 {
    grid-column: span 2;
  }
}

@media (max-width: 576px) {
  .form-row {
    grid-template-columns: 1fr;
    gap: var(--spacing-md);
  }

  .form-group.col-2,
  .form-group.col-3 {
    grid-column: 1;
  }

  .form-content {
    padding: var(--spacing-lg);
  }

  .form-header {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-md);
  }

  .form-header-actions {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/form-dense.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,+BAA+B;EAC/B,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;;;;;;;;;;EAUE,gCAAgC;EAChC,yBAAyB;EACzB,4CAA4C;EAC5C,kCAAkC;EAClC,+BAA+B;EAC/B,iCAAiC;EACjC,0BAA0B;EAC1B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;;;EAGE,aAAa;EACb,2BAA2B;EAC3B,gDAAgD;EAChD,6CAA6C;AAC/C;;AAEA;;;EAGE,mCAAmC;EACnC,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,yDAA0L;EAC1L,4BAA4B;EAC5B,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;;EAEE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAGE,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;;;EAGE,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/**\r\n * Form Dense - Compact form layout with 4-column grid\r\n * Professional, efficient form design\r\n */\r\n\r\n.form-wrapper {\r\n  max-width: 1200px;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.form-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: var(--spacing-lg);\r\n  border-bottom: 1px solid var(--border);\r\n  background-color: var(--bg-toolbar);\r\n}\r\n\r\n.form-header-breadcrumb {\r\n  font-size: var(--text-sm);\r\n  color: var(--text-muted);\r\n}\r\n\r\n.form-header-breadcrumb a {\r\n  color: var(--accent-l);\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  transition: color var(--transition-fast);\r\n}\r\n\r\n.form-header-breadcrumb a:hover {\r\n  color: #a5b4fc;\r\n}\r\n\r\n.form-header-title {\r\n  font-size: var(--text-xl);\r\n  font-weight: var(--fw-semibold);\r\n  color: var(--text-primary);\r\n  margin: 0;\r\n}\r\n\r\n.form-header-description {\r\n  font-size: var(--text-sm);\r\n  color: var(--text-muted);\r\n  margin: 0;\r\n}\r\n\r\n.form-header-actions {\r\n  display: flex;\r\n  gap: var(--spacing-sm);\r\n}\r\n\r\n.form-content {\r\n  padding: var(--spacing-xl);\r\n}\r\n\r\n.form-section {\r\n  margin-bottom: var(--spacing-xl);\r\n}\r\n\r\n.form-section:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.form-section-title {\r\n  font-size: var(--text-xs);\r\n  font-weight: var(--fw-bold);\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n  letter-spacing: 0.5px;\r\n  margin: 0 0 var(--spacing-md) 0;\r\n  padding-bottom: var(--spacing-sm);\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.form-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: var(--spacing-lg);\r\n  margin-bottom: var(--spacing-md);\r\n}\r\n\r\n.form-row:last-of-type {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.form-group.full {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.form-group.col-2 {\r\n  grid-column: span 2;\r\n}\r\n\r\n.form-group.col-3 {\r\n  grid-column: span 3;\r\n}\r\n\r\nlabel {\r\n  font-size: var(--text-sm);\r\n  font-weight: var(--fw-medium);\r\n  color: var(--slate-600);\r\n  margin-bottom: var(--spacing-xs);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n}\r\n\r\n.required {\r\n  color: var(--red-600);\r\n  font-weight: var(--fw-bold);\r\n}\r\n\r\n.help-text {\r\n  font-size: var(--text-xs);\r\n  color: var(--slate-400);\r\n  margin-top: 2px;\r\n}\r\n\r\n/* Form Controls */\r\ninput[type=\"text\"],\r\ninput[type=\"email\"],\r\ninput[type=\"password\"],\r\ninput[type=\"number\"],\r\ninput[type=\"date\"],\r\ninput[type=\"time\"],\r\ninput[type=\"datetime-local\"],\r\ninput[type=\"search\"],\r\nselect,\r\ntextarea {\r\n  font-family: var(--font-primary);\r\n  font-size: var(--text-sm);\r\n  padding: var(--spacing-sm) var(--spacing-md);\r\n  border: 1px solid var(--slate-300);\r\n  border-radius: var(--radius-sm);\r\n  background-color: var(--bg-input);\r\n  color: var(--text-primary);\r\n  transition: all var(--transition-fast);\r\n  appearance: none;\r\n}\r\n\r\ninput[type=\"text\"]::placeholder,\r\ninput[type=\"email\"]::placeholder,\r\ninput[type=\"password\"]::placeholder,\r\ninput[type=\"number\"]::placeholder,\r\ninput[type=\"search\"]::placeholder,\r\ntextarea::placeholder {\r\n  color: var(--text-muted);\r\n}\r\n\r\ninput:focus,\r\nselect:focus,\r\ntextarea:focus {\r\n  outline: none;\r\n  border-color: var(--accent);\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb),.2);\r\n  background-color: rgba(var(--accent-rgb),.07);\r\n}\r\n\r\ninput:disabled,\r\nselect:disabled,\r\ntextarea:disabled {\r\n  background-color: var(--bg-toolbar);\r\n  color: var(--text-muted);\r\n  cursor: not-allowed;\r\n}\r\n\r\nselect {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23818cf8' d='M6 9L1 4h10z'/%3E%3C/svg%3E\");\r\n  background-repeat: no-repeat;\r\n  background-position: right var(--spacing-md) center;\r\n  padding-right: 28px;\r\n}\r\n\r\ntextarea {\r\n  resize: vertical;\r\n  min-height: 80px;\r\n}\r\n\r\n/* Checkbox & Radio */\r\ninput[type=\"checkbox\"],\r\ninput[type=\"radio\"] {\r\n  width: 16px;\r\n  height: 16px;\r\n  margin: 0;\r\n  cursor: pointer;\r\n  accent-color: var(--blue-600);\r\n}\r\n\r\n.checkbox-group,\r\n.radio-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--spacing-sm);\r\n}\r\n\r\n.checkbox-item,\r\n.radio-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-sm);\r\n  cursor: pointer;\r\n}\r\n\r\n.checkbox-item label,\r\n.radio-item label {\r\n  margin-bottom: 0;\r\n  cursor: pointer;\r\n  font-weight: var(--fw-regular);\r\n}\r\n\r\n/* Error state */\r\n.form-group.error label {\r\n  color: var(--red-600);\r\n}\r\n\r\n.form-group.error input,\r\n.form-group.error select,\r\n.form-group.error textarea {\r\n  border-color: var(--red-600);\r\n}\r\n\r\n.form-group.error input:focus,\r\n.form-group.error select:focus,\r\n.form-group.error textarea:focus {\r\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\r\n  background-color: var(--red-50);\r\n}\r\n\r\n.error-message {\r\n  font-size: var(--text-xs);\r\n  color: var(--red-600);\r\n  margin-top: 2px;\r\n}\r\n\r\n/* Success state */\r\n.form-group.success input,\r\n.form-group.success select,\r\n.form-group.success textarea {\r\n  border-color: var(--green-600);\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 992px) {\r\n  .form-row {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .form-group.col-3 {\r\n    grid-column: span 2;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .form-row {\r\n    grid-template-columns: 1fr;\r\n    gap: var(--spacing-md);\r\n  }\r\n\r\n  .form-group.col-2,\r\n  .form-group.col-3 {\r\n    grid-column: 1;\r\n  }\r\n\r\n  .form-content {\r\n    padding: var(--spacing-lg);\r\n  }\r\n\r\n  .form-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: var(--spacing-md);\r\n  }\r\n\r\n  .form-header-actions {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
